import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/fonts.css';
import './styles/debug.css'; // Styles de débogage (activés avec ?debug=true dans l'URL)
import { StyleSheetManager } from 'styled-components';

// Déclaration type pour Matomo Analytics
declare global {
  interface Window {
    _paq: any[];
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <StyleSheetManager enableVendorPrefixes disableCSSOMInjection={process.env.NODE_ENV === 'development'}>
      <App />
    </StyleSheetManager>
  </React.StrictMode>
);